import useCheckMobileScreen from './useWidth';
import { IFormField, SelectDisplayType, SelectTypes } from '../schema/interface';

export const useNumberOfToggle = ({
    field,
    options
}: {
    field?: IFormField;
    options?: string[] | string[][];
}) => {
    const { smallSize: isMobile } = useCheckMobileScreen();
    const { smallSize: isSmallMobile } = useCheckMobileScreen(556);
    const { largeSize } = useCheckMobileScreen();
    const toggle =
        (field?.presentation?.selectType === SelectTypes.multi &&
            field?.presentation?.displayType === SelectDisplayType.Toggle) ||
        (field?.presentation?.selectType === SelectTypes.single &&
            field?.presentation?.displayType === SelectDisplayType.Toggle);
    const isToggle = field?.data_type === 'select' && toggle;
    const items = isToggle ? field?.metadata?.items : [];
    const length = items?.length;
    const pcColumn =
        length <= 3 ? 1 : length > 3 && length <= 6 ? 2 : length > 6 ? (largeSize ? 4 : 3) : null;
    const mobileColumn =
        pcColumn === 1
            ? 1
            : pcColumn === 2 && isMobile
            ? 2
            : pcColumn === 2 && isSmallMobile
            ? 1
            : pcColumn === 3 && isMobile
            ? 2
            : pcColumn === 3 && isSmallMobile
            ? 1
            : null;
    const column = isMobile || isSmallMobile ? mobileColumn : pcColumn;
    /* eslint-disable no-unneeded-ternary */
    const isLong =
        options?.length > 6 && (isMobile || isSmallMobile)
            ? true
            : options?.length >= 10
            ? true
            : false;

    return { isToggle, column, isLong };
};
